import React, { Component } from 'react';
import './spinDialogDevices.less';
import { Spin } from 'antd';



//设备设置界面
export default class SpinDialogDevices extends Component {
    constructor(a) {
        super(a);
    }


    render() {
        return (
            <div className="spin_container_devices">
                <div className="spin_grey_bg_devices" />
                <div className="spin_dialog_devices" style={{ left: (document.body.clientWidth - 400) / 2 }}>

                    <Spin className='loading_devices' style={{ marginTop: 40 }} size="large"></Spin>
                    <h3>Refreshing Device Information...</h3>

                </div>
            </div>
        );

    }
};
